import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PerchéHero from './components/PerchéHero';
import VantaggiSections from './components/VantaggiSections';
import CTAFinale from './components/CTAFinale';
import { useSEO } from '../../utils/seo';

export default function PerchéValorizzarePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'Perché Valorizzare il Brand - Vantaggi Valutazione Marchio Aziendale',
    description: 'Scopri i vantaggi della valorizzazione del brand: accesso al credito, M&A, bilancio, successione aziendale, protezione legale. Aumenta il valore patrimoniale della tua azienda con una perizia certificata.',
    keywords: 'valorizzazione brand, vantaggi valutazione marchio, asset intangibili, valore brand aziendale',
    canonical: `${siteUrl}/perche-valorizzare`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Perché Valorizzare il Brand Aziendale',
      description: 'I vantaggi strategici e patrimoniali della valorizzazione del brand',
      author: {
        '@type': 'Organization',
        name: 'Brand Capital'
      },
      publisher: {
        '@type': 'Organization',
        name: 'Brand Capital',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      },
      datePublished: '2024-01-01',
      dateModified: new Date().toISOString().split('T')[0]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PerchéHero />
      <VantaggiSections />
      <CTAFinale />
      <Footer />
    </div>
  );
}
